import { createContext, useContext, useEffect, useRef } from 'react';

type BackHandler = () => void | Promise<void>;

interface BackHandlerContextType {
    registerHandler: (handler: BackHandler) => void;
    unregisterHandler: (handler: BackHandler) => void;
    handleBack: () => Promise<boolean>; // Returns true if handled
}

export const BackHandlerContext = createContext<BackHandlerContextType | null>(null);

export const useBackHandler = (handler: BackHandler, enabled: boolean = true) => {
    const context = useContext(BackHandlerContext);
    const handlerRef = useRef(handler);

    // Keep ref fresh
    useEffect(() => {
        handlerRef.current = handler;
    }, [handler]);

    useEffect(() => {
        if (!enabled || !context) return;

        const currentHandler = () => handlerRef.current();
        context.registerHandler(currentHandler);

        return () => {
            context.unregisterHandler(currentHandler);
        };
    }, [enabled, context]);
};
